import React from 'react';
import {useTranslation} from 'react-i18next';
import history from '../../history';
import {useDispatch, useSelector} from 'react-redux';
import * as actions from '../../store/actions';
import {ReduxState} from '../../store/types';
import ChangePasswordForm from '../../components/Forms/LoginForm/ChangePasswordForm';
import {MailMePayload} from '../../store/actions/auth/payloads';
import {getTranslationByFaultString, isPasswordErrorCorrectableOnForm, useQuery} from './ResetPassword.utils';
import {Routes} from '../../routes/routes';
import usePageTitle from '../../hooks/usePageTitle';
import AuthWrapper from '../../components/AuthWraper/AuthWrapper';


const ResetPassword = () => {

    const dispatch = useDispatch();
    const recoveryId = useQuery().get('nonce');
    usePageTitle();

    const {session_id, errors, passwordRecovered} = useSelector(
        (state: ReduxState) => state.auth,
    );
    const {t} = useTranslation();

    if (!recoveryId) {
        history.push(Routes.SignIn);
    }

    if (session_id) {
        history.push(Routes.Default);
    }
    
    const correctableOnForm = isPasswordErrorCorrectableOnForm(errors?.faultstring);

    if (errors?.faultstring?.length &&!correctableOnForm) {
        history.push(Routes.SignIn);
        setTimeout(() => {
            dispatch(actions.loginClearErrors());
        }, 10);
    }

    const dispatchEmailMeAction = (payload: MailMePayload) => {
        dispatch(actions.passwordRecovery.request(payload));
    };

    const handleOnCloseSnackbar = () => {
        dispatch(actions.loginClearErrors());
        if (passwordRecovered) {
            history.push(Routes.SignIn);
        }
    };

    const localizedMessage = errors && correctableOnForm
    ? getTranslationByFaultString(errors.faultstring)
    : undefined;

    return (
        <AuthWrapper
            title={t('screens:signIn.resetPassword')}
            message={localizedMessage}
            onSnackbarClose={handleOnCloseSnackbar}
        >
            <ChangePasswordForm
                changePasswordAction={dispatchEmailMeAction}
                validateOnChange={false}
                recoveryId={recoveryId ? recoveryId : ''}
                dataQa={'recovery-password-form'}
                apiErrors={errors ? errors : undefined}
            />
        </AuthWrapper>
    );
};

export default ResetPassword;
